module.exports = __webpack_public_path__ + "static/img/dzxgs.d1af389.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dzxgs.jpg
// module id = feNr
// module chunks = 4